import { useState } from "react"
import { useTranslation } from "react-i18next"
import Modal from "react-responsive-modal"
import store from "../../../../../storeClient"
import ConsultasClient from "../../../../api/consultas"

const ConsultaModalBanner = ({ consultaBanner, onClose }) => {
  const { t } = useTranslation()
  const [nombre, setNombre] = useState("")
  const [apellido, setApellido] = useState("")
  const [email, setEmail] = useState("")
  const [telefono, setTelefono] = useState("")
  const [comentarios, setComentarios] = useState("")
  const { token } = store.getState().applicationState
  const empresaId = store.getState().applicationState.applicationId
  const nombreAgencia = store.getState().applicationState.nombre
  const paisId = store.getState().applicationState.paisId
  const emailAgencia =
    store.getState().applicationState.templateData?.header.emailContacto

  const handleNombreChange = (event) => {
    setNombre(event.target.value)
  }

  const handleApellidoChange = (event) => {
    setApellido(event.target.value)
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handleTelefonoChange = (event) => {
    const value = event.target.value;
    if (value.length <= 20) {
      setTelefono(value)
    }
  }

  const handleComentariosChange = (event) => {
    setComentarios(event.target.value)
  }

  const enviarConsulta = (event) => {
    event.preventDefault()
    let data = {
      nombre: nombre,
      apellido: apellido,
      email: email,
      comentarios: comentarios,
      agenciaId: empresaId,
      nombreAgencia: nombreAgencia,
      paisId: paisId,
      emailAgencia: emailAgencia,
      bannerId: consultaBanner.id,
      bannerTitle: consultaBanner.titulo,
      bannerDescription: consultaBanner.descripcion,
      telefono,
      totalDias: 0,
      totalAdultos: 0,
      totalNinos: 0,
      mes: "",
      year: 0,
      destino: "",
      id: 0,
      estado: {
        id: 1,
      },
      tipoConsulta: "banners",
      banner: {
        id: consultaBanner.id,
      },
      proveedor: consultaBanner.proveedor,
    }
    ConsultasClient.consultaMarcaBlanca(data, token).then((res) => {
      if (res.status === 201) {
        data.id = res.data.id
        ConsultasClient.enviarMailConsulta(data, token).then((res) => {
          if (res.status === 201) {
            console.log("Email Sent")
          } else {
            console.error("EMAIL - Error")
          }
        })
        alert("La consulta se envió correctamente")
        resetForm()
        onClose()
      } else {
        alert("La consulta no se pudo enviar")
      }
    })
  }

  const resetForm = () => {
    setNombre("")
    setApellido("")
    setEmail("")
    setTelefono("")
    setComentarios("")
  }

  return (
    !!consultaBanner && (
      <Modal
        classNames={{ modal: "package-modal consulta-package-modal" }}
        open
        onClose={onClose}
      >
        <div className="modal-package-search__header">
          <i className="fa fa-paper-plane package-search__icon text-footer-default" />
          <div className="package-search__form__title">Enviá tu consulta</div>
        </div>
          <form className="form-inline consulta-modal__content" onSubmit={enviarConsulta}>
            <div className="form-group">
              <div className="clearfix" />
              <span className="block text-gray-700 text-sm font-bold mb-2">
                {t("requestForm.name")} (*)
              </span>
              <input
                id="nombre"
                onChange={handleNombreChange}
                value={nombre}
                name="nombre"
                type="text"
                maxLength={50}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                required
              />
            </div>
            <div className="form-group">
              <div className="clearfix" />
              <span className="block text-gray-700 text-sm font-bold mb-2">
                {t("requestForm.lastName")} (*)
              </span>
              <input
                id="apellido"
                onChange={handleApellidoChange}
                value={apellido}
                name="apellido"
                type="text"
                maxLength={50}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                required
              />
            </div>
            <div className="form-group">
              <span className="block text-gray-700 text-sm font-bold mb-2">
                E-mail (*)
              </span>
              <input
                id="email"
                onChange={handleEmailChange}
                value={email}
                name="email"
                type="email"
                maxLength={50}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                required
              />
            </div>
            <div className="form-group">
              <span className="block text-gray-700 text-sm font-bold mb-2">
                {t("requestForm.phone")}
              </span>
              <input
                id="telefono"
                onChange={handleTelefonoChange}
                value={telefono}
                name="telefono"
                type="number"
                maxLength={20}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
              />
            </div>
            <div className="form-group">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="comentarios"
              >
                {t("requestForm.message")} (*)
              </label>
              <textarea
                id="comentarios"
                onChange={handleComentariosChange}
                value={comentarios}
                name="comentarios"
                className="h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                rows="5"
                placeholder={t("requestForm.commentsPlaceholder")}
                required
              />
            </div>
            <div className="package-search__button-row">
              <button
                type="submit"
                className="package-search__button big-package-search__button"
              >
                <i className="fa fa-paper-plane heading__icon" />
                Enviar
              </button>
            </div>
          </form>
      </Modal>
    )
  )
}

export default ConsultaModalBanner
